import { Theme } from "@mui/material";

const privacyStyle = {
  privacyPage: (theme: Theme) => ({
    margin: "2rem 0",
    [theme.breakpoints.up("md")]: {
      margin: "5rem 0",
    },
  }),
  list: {
    listStyleType: "none",
  },
  headline: {
    hyphens: "auto",
  },
};

export default privacyStyle;
